var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5001 13.5001C6.5001 13.5001 4.5 15.2486 4.5 16.2495C4.5 17.2503 4.5 18.2495 4.5 18.2495M6.5001 13.5001L6.7501 12.6501M6.5001 13.5001H18.0001M18.0001 13.5001C18.0001 13.5001 20 15.2486 20 16.2495C20 17.2503 20 18.2495 20 18.2495M18.0001 13.5001L17.8001 12.6501M20 18.2495C20 18.2495 20 18.4988 20 19.4996C20 20.5004 19.4629 20.5 18.875 20.5C18.2873 20.5 17.75 20.5004 17.75 19.5004C17.75 18.5003 17.75 18.2495 17.75 18.2495M20 18.2495H17.75M4.5 18.2495C4.5 18.2495 4.5 18.7488 4.5 19.4996C4.5 20.2504 5.03722 20.4996 5.62505 20.4996C6.21288 20.4996 6.7501 20.2504 6.7501 19.4996C6.7501 18.7488 6.7501 18.2495 6.7501 18.2495M4.5 18.2495H6.7501M5 12.2501L6.7501 12.6501M6.7501 12.6501C6.7501 12.6501 7 10 8 10C9 10 15.5558 10 16.5 10C17.4442 10 17.8001 12.6501 17.8001 12.6501M19.5 12.2501L17.8001 12.6501M6.7501 18.2495H17.75",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.5L11.4426 5.38139C11.7794 5.15095 12.2224 5.14828 12.562 5.37465L21.75 11.5",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarport);
export default __webpack_public_path__ + "static/media/carport.e93cedab40498cfbd7e764147b332692.svg";
export { ForwardRef as ReactComponent };